const nameRules = [v => !!v || 'Name is required'];
const colorRules = [v => !!v || 'Color is required'];
const macRules = [
    v => !!v || 'MAC address is required',
    v => /^([0-9A-Fa-f]{1,2}:){3}[0-9A-Fa-f]{1,2}$/.test(v) || 'Invalid MAC address format'
  ];
  const descriptiveRules = [
    (value) => !!value || "The file is required",
    (value) => {
      const file = value;
      if (file.type !== "application/json") {
        return "The file must be a JSON";
      }
      return true;
    },
    async (value) => {
      if (!value) return true;
  
      try {
        const text = await value.text();
        const json = JSON.parse(text);
  
        if (typeof json !== "object" || Array.isArray(json)) {
          return "The JSON must be an object with key-value pairs";
        }
  
        const validSQLTypes = new Set(["TEXT", "SMALLINT", "DOUBLE", "INT", "TIMESTAMP"]);
        const validFieldTypes = new Set(["latitude","longitude","time","heading","wind_speed","wind_angle","wp_longitude","wp_latitude"])
  
        const fieldOccurrences = {};


        let hasLatitude = false;
        let hasLongitude = false;
        let hasTime = false;
  
        for (const key in json) {
          const fieldConfig = json[key];
  
          if (typeof fieldConfig !== "object" || Array.isArray(fieldConfig)) {
            return `The value for "${key}" must be an object with 'type' and 'visible' fields.`;
          }
  
          const { type, visible, field } = fieldConfig;
  
          // Validar type
          if (!type || typeof type !== "string") {
            return `Field "${key}" must have a "type" as a string.`;
          }
  
          if (!validSQLTypes.has(type.toUpperCase())) {
            return `The type "${type}" in "${key}" is not valid.`;
          }
  
          // Validar visible
          if (visible !== undefined && typeof visible !== "number" && typeof visible !== "boolean") {
            return `If present, "visible" in "${key}" must be a number or boolean.`;
          }
  
          // Validar field
          if (field !== undefined) {

            if(visible!== undefined && visible!=1){
              return `"field" in "${key}" must have "visible=1".`;

            }

            if (!validFieldTypes.has(field)) {
              return `"field" in "${key}" must be a valid field.`;
            }

            if (fieldOccurrences[field]) {
              return `Field "${field}" is defined more than once. Only one instance is allowed.`;
            }
            fieldOccurrences[field] = true;

            // Marca los obligatorios como presentes
            if (field === "latitude" && type.toUpperCase() === "DOUBLE") hasLatitude = true;
            if (field === "longitude" && type.toUpperCase() === "DOUBLE") hasLongitude = true;
            if (field === "time" && type.toUpperCase() === "TIMESTAMP") hasTime = true;
          }
        }
  
        if (!hasLatitude || !hasLongitude || !hasTime) {
          return `The JSON must include fields: latitude, longitude and time. Latitude and longitude as type double and time as type timestamp`;
        }
  
        return true;
      } catch (error) {
        return `Error in the JSON file: ${error}`;
      }
    }
  ];
const iconRules = [v => !!v || 'Icon is required'];
const tooltipText = `
El archivo JSON debe tener la siguiente estructura:

- Debe ser un objeto con claves que representen los nombres de las columnas.
- Cada clave debe tener como valor un objeto con los siguientes campos:

  - "type": Tipo de dato SQL permitido (obligatorio).
  - "visible": 1 (visible) o 0 (oculto) / true o false (obligatorio).
  - "field": Nombre del campo original.

Tipos de "field" permitidos:
  - latitude (obligatorio)
  - longitude (obligatorio)
  - time (obligatorio)
  - heading (opcional)
  - wind_speed (opcional)
  - wind_angle (opcional)
  - wp_longitude (opcional)
  - wp_latitude (opcional)

Tipos de datos permitidos para "type":
- TEXT
- INT
- DOUBLE
- TIMESTAMP

Ejemplo:

{
  "boat_latitude": { "type": "DOUBLE", "visible": 1, "field": "latitude" },
  "boat_longitude": { "type": "DOUBLE", "visible": 1, "field": "longitude" },
  "pitch": { "type": "DOUBLE", "visible": 1 },
  "name": { "type": "TEXT", "visible": 1 },
  "created_at": { "type": "TIMESTAMP", "visible": 0, "field":"time" }
}
`;
export {
    nameRules,colorRules,macRules,descriptiveRules,iconRules,tooltipText
}